<div style="padding: 24px;" *ngIf="!data || !data.title">
  <div class="mb-4">
    <div class="form-group mb-4">
      <h6 class="mb-4">
        Are you sure want to skip with out copying a Template ?
      </h6>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <!-- <button class="float-right ml-1 btn btn-sm " mat-button style="width: 25%;" (click)="continue()">
      Yes
    </button>
    <button class="float-right ml-auto btn btn-sm " mat-button style="width: 25%;" (click)="cancel()">
      No
    </button> -->
      <button mat-button (click)="continue()" class="btn btn-default copy btn-sm">
        Yes
      </button>
      <button mat-button class="btn btn-default skip btn-sm" (click)="cancel()">No</button>
    </div>
  </div>
</div>
<ng-container *ngIf="data && data.title">
  <div mat-dialog-title>
    {{data.title | translate}}
  </div>
  <div class="mb-3" mat-dialog-content>
    <span *ngIf="!data.form_enable && data.message">{{data.message | translate}}
      <ng-container *ngIf="data &&!data.message1">
        ?
      </ng-container>
      <ng-container *ngIf="data &&data.message1">
        <i>
          {{data.message1}} ?
        </i>
      </ng-container>
    </span>
    <ng-container>
      <div class="col-md-12" *ngIf="data.assessment &&data.assessment.length">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <th class="col-md-4 col-width-100">
                {{ "ALERT.questions" | translate }}
              </th>
              <th style="text-align: center" class="col-md-4">
                {{ "ALERT.response" | translate }}
              </th>
            </thead>
            <tbody>
              <tr *ngFor="let question of data.assessment ; let i =index">
                <td style="white-space: normal !important; vertical-align: middle;" [title]="question.title">
                  <span class="multi-line-truncate-2">
                    {{question.title | translate}}
                  </span>
                </td>
                <td style=" vertical-align: middle;">
                  <mat-radio-group [(ngModel)]="question.selectedOption" [ngModelOptions]="{standalone: true}">
                    <mat-radio-button class="mx-1" *ngFor="let item of question.options" [value]="item.optionCode">
                      {{item.title | translate}}
                    </mat-radio-button>
                  </mat-radio-group>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
  </div>
  <div mat-dialog-actions>
    <button style="min-width: 100px;" class="  blob-btn-cancel ml-auto btn mx-1 mx-1 tallite-action" (click)="cancel()">
      <ng-container *ngIf="data &&data.negative_button">
        {{data.negative_button | translate}}
      </ng-container>
      <ng-container *ngIf="data &&!data.negative_button">
        {{'BTN.no' |translate}}
      </ng-container>

      <span class="blob-btn-cancel__inner">
        <span class="blob-btn-cancel__blobs">
          <span class="blob-btn-cancel__blob"></span>
          <span class="blob-btn-cancel__blob"></span>
          <span class="blob-btn-cancel__blob"></span>
          <span class="blob-btn-cancel__blob"></span>
        </span>
      </span>
    </button>
    <button style="min-width: 100px;" class="blob-btn  btn   mx-1  tallite-action" type="submit"
      [mat-dialog-close]="{flag:1}">
      <ng-container *ngIf="data && data.positive_button">
        {{data.positive_button | translate}}
      </ng-container>
      <ng-container *ngIf="data && !data.positive_button">
        {{'BTN.yes' |translate}}
      </ng-container>
      <span class="blob-btn__inner">
        <span class="blob-btn__blobs">
          <span class="blob-btn__blob"></span>
          <span class="blob-btn__blob"></span>
          <span class="blob-btn__blob"></span>
          <span class="blob-btn__blob"></span>
        </span>
      </span>
    </button>


    <!-- <button class="ml-1 btn btn-sm btn-danger" style="width: 40%;" (click)="cancel()" *ngIf="data.negative_button">
      {{data.negative_button | translate}}
    </button>
    <button class="ml-auto btn btn-sm btn-info" style="width: 40%;" [mat-dialog-close]="{flag:1}"
      *ngIf="data.positive_button">
      {{data.positive_button | translate}}
    </button> -->


  </div>
</ng-container>
